module.exports = __webpack_public_path__ + "img/IAAS_back_logo.6c31e8fd.png";